import colors from "./colors-generator";

/**
 * Maps the color property from the Frontdoor API to internal theme modes.
 * API returns: "default", "dark", "light"
 * Internal modes: "default_theme", "night_theme", "light_theme"
 */
export const ColorToThemeMode = {
  default: "default_theme",
  dark: "night_theme",
  light: "light_theme",
};

/**
 * Maps internal theme modes to the color property for API calls.
 */
export const ThemeModeToColor = {
  default_theme: "default",
  night_theme: "dark",
  light_theme: "light",
};

/**
 * Available theme modes for the UI.
 */
export const ThemeModes = {
  Default: "default_theme",
  Light: "light_theme",
  Night: "night_theme",
};

export const ThemePalettes = {
  default_theme: {
    // default theme
    ...colors,
    primary: {
      contrastText: "#fff",
      dark: "#05060F",
      light: "#EAEAEB",
      main: "#3C2884",
      // main: "#1E1F27",
      // ...colors.primary,
    },
    text: { primary: colors.base[100], secondary: colors.base[100] },
    custom: {
      heading: "#24183D",
      header_bg: "#24183D",
      header_text: "#FFFFFF",
      primary_main: "#3C2884",
      primary_button: "#3C2884",
      primary_button_text: "#FFFFFF",
      primary_button_text_default: "#FFFFFF",

      secondary_button_stroke: "#6A4FCA",
      secondary_button_text: "#3C2884",
      secondary_button_text_default: "#3C2884",
      secondary_button: "#EBE8F8",
      secondary_button_hover: "#C9C0EC",
      secondary_button_stroke_hover: "#5035B0",
      secondary_button_light: "#F5F3FF",
      secondary_main: "#EBE8F8",
      background: "#F4F4F6",
      orange_shade: "#FF6737",
      hover_color: "#4E34AC",
      grid_header: "#EEEEF1",
      grid_table: "#FBFBFB",
      container: "#FFFFFF",
      sub_heading: "#111111",
      grey_text: "#525252",
      stroke: "#E3E3E8",
      text: "#111111",
      disabled_button: "#F9F9F9",
      disabled_button_text: "#8c8c8c",
      success: "#005C00",
      info: "#404040",
      warning: "#5C4D00",
      error: "#5C0000",
      active: "#001F5C",
      default: "#14005C",
      success_bg: "#CCFFCC",
      info_bg: "#EFEFEF",
      warning_bg: "#FFF6CC",
      error_bg: "#FFCCCC",
      active_bg: "#CCDDFF",
      default_bg: "#D7CCFF",
    },
  },
  light_theme: {
    // light theme
    ...colors,
    primary: {
      contrastText: "#fff",
      dark: "#1C85E8",
      light: "#D2E7FA",
      main: "#3C2884",
      // main: "#499DED",
    },
    text: { primary: colors.base[100], secondary: colors.base[100] },
    custom: {
      heading: "#000000",
      header_bg: "#E7E4E4",
      header_text: "#24183D",
      primary_main: "#3C2884",
      primary_button: "#3C2884",
      primary_button_text: "#FFFFFF",
      primary_button_text_default: "#FFFFFF",

      secondary_button_stroke: "#8058DF",
      secondary_button_text: "#3C2884",
      secondary_button_text_default: "#3C2884",
      secondary_button: "#EBE8F8",
      secondary_button_hover: "#C9C0EC",
      secondary_button_stroke_hover: "#602DD7",
      secondary_button_light: "#F5F3FF",
      secondary_main: "#EBE8F8",
      background: "#F3F3F3",
      orange_shade: "#FF6737",
      hover_color: "#4E34AC",
      grid_header: "#EDEDED",
      grid_table: "#F5F5F5",
      container: "#FAFAFA",
      sub_heading: "#292929",
      grey_text: "#525252",
      stroke: "#E8E8E8",
      text: "#111111",
      disabled_button: "#F9F9F9",
      disabled_button_text: "#8c8c8c",
      success: "#005C00",
      info: "#404040",
      warning: "#5C4D00",
      error: "#5C0000",
      active: "#001F5C",
      default: "#14005C",
      success_bg: "#CCFFCC",
      info_bg: "#EFEFEF",
      warning_bg: "#FFF6CC",
      error_bg: "#FFCCCC",
      active_bg: "#CCDDFF",
      default_bg: "#D7CCFF",
    },
  },
  night_theme: {
    // night theme
    ...colors,
    primary: {
      contrastText: "#fff",
      dark: "#DB2323",
      light: "#F8D3D3",
      main: "#7762C3",
    },
    text: { primary: colors.base[100], secondary: colors.base[100] },
    custom: {
      heading: "#FFFFFF",
      header_bg: "#16151E",
      header_text: "#FFFFFF",
      primary_main: "#4C3894",
      primary_button: "#4C3894",
      primary_button_text: "#FFFFFF",
      primary_button_text_default: "#FFFFFF",

      secondary_button_stroke: "#7F6BC7",
      secondary_button_text: "#C2B9E4",
      secondary_button_text_default: "#C2B9E4",
      secondary_button: "#251F37",
      secondary_button_hover: "#3B3258",
      secondary_button_stroke_hover: "#9F90D5",
      secondary_button_light: "#3B3258",
      secondary_main: "#251F37",
      background: "#1F1D2B",
      orange_shade: "#FF8B66",
      hover_color: "#5F46B9",
      grid_header: "#232131",
      grid_table: "#292B38",
      container: "#2D303E",
      sub_heading: "#F5F5F5",
      grey_text: "#CCCCCC",
      stroke: "#4E5059",
      text: "#F0F0F0",
      disabled_button: "#29272F",
      disabled_button_text: "#808080",
      success: "#8AFF8A",
      info: "#C4C4C4",
      warning: "#FFEB8A",
      error: "#FF8A8A",
      active: "#8AB1FF",
      default: "#A38AFF",
      success_bg: "#003300",
      info_bg: "#1A1A1A",
      warning_bg: "#332A00",
      error_bg: "#330000",
      active_bg: "#001133",
      default_bg: "#0B0033",
      survey_element_toolbar_item_active: "#4C3894",
    },
  },
  // theme_4: {
  //   primary: {
  //     contrastText: "#fff",
  //     dark: "#F1C21B",
  //     light: "#F9E7A4",
  //     main: "#F4CE49",
  //   },
  // },
  // theme_5: {
  //   primary: {
  //     contrastText: "#fff",
  //     dark: "#1D2C4C",
  //     light: "#D2D5DB",
  //     main: "#4A5670",
  //   },
  // },
};

export const CustomTypography = {
  fontFamily: "Roboto",
  // fontFamilyCode: 'Menlo,Consolas,"Droid Sans Mono",monospace',
  fontFamilyTagline: "Roboto",
  fontFamilySystem: "Roboto",
  fontWeightSemiBold: 600,
  fontWeightExtraBold: 800,
  h1: {
    fontFamily: "Roboto",
    fontSize: "clamp(1.5rem, 1.0426rem + 1.2578vw, 2.25rem)",
    fontWeight: 800,
    lineHeight: 1.1142857142857143,
    color: "#0A1929",
    scrollMarginTop: "calc(var(--MuiDocs-header-height) + 72px)",
  },
  h2: {
    fontFamily: "Roboto",
    fontSize: "clamp(1.25rem, 1.0342rem + 1.2498vw, 1.875rem)",
    fontWeight: 800,
    lineHeight: 1.2222222222222223,
    color: "#132F4C",
    scrollMarginTop: "calc(var(--MuiDocs-header-height) + 72px)",
  },
  h3: {
    fontFamily: "Roboto",
    fontSize: "clamp(1.5rem, calc(0.6842rem + 0.8498vw), 2rem)",
    lineHeight: 1.2222222222222223,
    letterSpacing: 0.2,
    fontWeight: 500,
    scrollMarginTop: "calc(var(--MuiDocs-header-height) + 72px)",
  },
  h4: {
    fontFamily: "Roboto",
    fontSize: "1.25rem",
    lineHeight: 1.5,
    letterSpacing: 0.2,
    fontWeight: 500,
    scrollMarginTop: "calc(var(--MuiDocs-header-height) + 72px)",
  },
  h5: {
    fontFamily: "Roboto",
    fontSize: "1.0rem",
    lineHeight: 1.5,
    letterSpacing: 0.1,
    // color: "#007FFF",
    fontWeight: 500,
    scrollMarginTop: "calc(var(--MuiDocs-header-height) + 72px)",
  },
  h6: {
    fontSize: "clamp(1rem, calc(0.5682rem + 0.4498vw), 1.5rem)",
    lineHeight: 1.5,
    fontFamily: "Roboto",
    fontWeight: 500,
    scrollMarginTop: "calc(var(--MuiDocs-header-height) + 72px)",
  },
  button: {
    textTransform: "initial",
    fontWeight: 700,
    letterSpacing: 0,
    fontFamily: "Roboto",
    fontSize: "0.875rem",
    lineHeight: 1.75,
    borderRadius: "5px",
    scrollMarginTop: "calc(var(--MuiDocs-header-height) + 72px)",
  },
  subtitle1: {
    fontSize: "1.125rem",
    lineHeight: 1.3333333333333333,
    letterSpacing: 0,
    fontWeight: 500,
    fontFamily: "Roboto",
    scrollMarginTop: "calc(var(--MuiDocs-header-height) + 72px)",
  },
  body1: {
    fontSize: "1rem",
    lineHeight: 1.5,
    letterSpacing: 0,
    fontFamily: "Roboto",
    fontWeight: 400,
    scrollMarginTop: "calc(var(--MuiDocs-header-height) + 72px)",
  },
  body2: {
    fontSize: "0.875rem",
    lineHeight: "1.5rem",
    letterSpacing: 0,
    fontFamily: "Roboto",
    fontWeight: 400,
    scrollMarginTop: "calc(var(--MuiDocs-header-height) + 72px)",
  },
  span: {
    fontSize: "0.688rem",
    lineHeight: 1.5,
    letterSpacing: 0,
    fontFamily: "Roboto",
    fontWeight: 400,
    scrollMarginTop: "calc(var(--MuiDocs-header-height) + 72px)",
  },
  caption: {
    display: "inline-block",
    fontSize: "0.75rem",
    lineHeight: 1.5,
    letterSpacing: 0,
    fontWeight: 700,
    fontFamily: "Roboto",
    scrollMarginTop: "calc(var(--MuiDocs-header-height) + 72px)",
  },
  allVariants: {
    fontSize: "0.875rem",
    scrollMarginTop: "calc(var(--MuiDocs-header-height) + 72px)",
  },
  htmlFontSize: 16,
  fontSize: 14,
  fontWeightLight: 300,
  fontWeightRegular: 400,
  fontWeightMedium: 500,
  fontWeightBold: 700,
  subtitle2: {
    fontFamily: "Roboto",
    fontWeight: 500,
    fontSize: "0.875rem",
    lineHeight: 1.57,
    scrollMarginTop: "calc(var(--MuiDocs-header-height) + 72px)",
  },
  overline: {
    fontFamily: "Roboto",
    fontWeight: 400,
    fontSize: "0.75rem",
    lineHeight: 2.66,
    textTransform: "uppercase",
    scrollMarginTop: "calc(var(--MuiDocs-header-height) + 72px)",
  },
  inherit: {
    fontFamily: "inherit",
    fontWeight: "inherit",
    fontSize: "inherit",
    lineHeight: "inherit",
    letterSpacing: "inherit",
  },
};

// {
//   "breakpoints": {
//       "keys": [
//           "xs",
//           "sm",
//           "md",
//           "lg",
//           "xl"
//       ],
//       "values": {
//           "xs": 0,
//           "sm": 600,
//           "md": 900,
//           "lg": 1200,
//           "xl": 1536
//       },
//       "unit": "px"
//   },
//   "direction": "ltr",
//   "components": {
//       "MuiCssBaseline": {
//           "defaultProps": {
//               "enableColorScheme": true
//           }
//       },
//       "MuiButtonBase": {
//           "defaultProps": {
//               "disableTouchRipple": true
//           }
//       },
//       "MuiButton": {
//           "defaultProps": {
//               "disableElevation": true
//           },
//           "styleOverrides": {},
//           "variants": [
//               {
//                   "props": {
//                       "variant": "code"
//                   }
//               },
//               {
//                   "props": {
//                       "variant": "link"
//                   }
//               }
//           ]
//       },
//       "MuiIconButton": {
//           "variants": [
//               {
//                   "props": {
//                       "color": "primary"
//                   }
//               }
//           ]
//       },
//       "MuiMenu": {
//           "styleOverrides": {}
//       },
//       "MuiPopover": {
//           "styleOverrides": {}
//       },
//       "MuiDivider": {
//           "styleOverrides": {}
//       },
//       "MuiLink": {
//           "defaultProps": {
//               "underline": "none"
//           },
//           "styleOverrides": {
//               "root": {
//                   "fontWeight": 700,
//                   "display": "inline-flex",
//                   "alignItems": "center",
//                   "&.MuiTypography-body1 > svg": {
//                       "marginTop": 2
//                   },
//                   "& svg:last-child": {
//                       "marginLeft": 2
//                   }
//               }
//           },
//           "variants": [
//               {
//                   "props": {
//                       "color": "primary"
//                   }
//               }
//           ]
//       },
//       "MuiChip": {
//           "styleOverrides": {}
//       },
//       "MuiList": {
//           "styleOverrides": {
//               "root": {
//                   "padding": 0
//               }
//           }
//       },
//       "MuiListItemButton": {
//           "styleOverrides": {}
//       },
//       "MuiSelect": {
//           "defaultProps": {
//               "IconComponent": {
//                   "type": {},
//                   "compare": null
//               }
//           },
//           "styleOverrides": {
//               "iconFilled": {
//                   "top": "calc(50% - .25em)"
//               }
//           }
//       },
//       "MuiTab": {
//           "defaultProps": {
//               "disableTouchRipple": true
//           },
//           "styleOverrides": {}
//       },
//       "MuiPaper": {
//           "styleOverrides": {}
//       },
//       "MuiTableCell": {
//           "styleOverrides": {}
//       },
//       "MuiToggleButtonGroup": {
//           "styleOverrides": {}
//       },
//       "MuiToggleButton": {
//           "styleOverrides": {}
//       },
//       "MuiTooltip": {
//           "styleOverrides": {
//               "tooltip": {
//                   "padding": "6px 12px"
//               }
//           }
//       },
//       "MuiSwitch": {
//           "styleOverrides": {
//               "root": {
//                   "width": 32,
//                   "height": 20,
//                   "padding": 0,
//                   "& .MuiSwitch-switchBase": {
//                       "&.Mui-checked": {
//                           "transform": "translateX(11px)",
//                           "color": "#fff"
//                       }
//                   }
//               },
//               "switchBase": {
//                   "height": 20,
//                   "width": 20,
//                   "padding": 0,
//                   "color": "#fff",
//                   "&.Mui-checked + .MuiSwitch-track": {
//                       "opacity": 1
//                   }
//               },
//               "thumb": {
//                   "flexShrink": 0,
//                   "width": "14px",
//                   "height": "14px"
//               }
//           }
//       },
//       "MuiPaginationItem": {
//           "styleOverrides": {}
//       }
//   },
//   "palette": {
//       "mode": "light",
//       "primary": {
//           "50": "#F0F7FF",
//           "100": "#C2E0FF",
//           "200": "#99CCF3",
//           "300": "#66B2FF",
//           "400": "#3399FF",
//           "500": "#007FFF",
//           "600": "#0072E5",
//           "700": "#0059B2",
//           "800": "#004C99",
//           "900": "#003A75",
//           "main": "#007FFF",
//           "light": "#66B2FF",
//           "dark": "#0059B2",
//           "contrastText": "#fff"
//       },
//       "divider": "#E7EBF0",
//       "primaryDark": {
//           "50": "#E2EDF8",
//           "100": "#CEE0F3",
//           "200": "#91B9E3",
//           "300": "#5090D3",
//           "400": "#265D97",
//           "500": "#1E4976",
//           "600": "#173A5E",
//           "700": "#132F4C",
//           "800": "#001E3C",
//           "900": "#0A1929",
//           "main": "#5090D3"
//       },
//       "common": {
//           "black": "#1D1D1D",
//           "white": "#fff"
//       },
//       "text": {
//           "primary": "#1A2027",
//           "secondary": "#3E5060",
//           "disabled": "rgba(0, 0, 0, 0.38)"
//       },
//       "grey": {
//           "50": "#F3F6F9",
//           "100": "#E7EBF0",
//           "200": "#E0E3E7",
//           "300": "#CDD2D7",
//           "400": "#B2BAC2",
//           "500": "#A0AAB4",
//           "600": "#6F7E8C",
//           "700": "#3E5060",
//           "800": "#2D3843",
//           "900": "#1A2027",
//           "main": "#E7EBF0",
//           "contrastText": "#6F7E8C",
//           "A100": "#f5f5f5",
//           "A200": "#eeeeee",
//           "A400": "#bdbdbd",
//           "A700": "#616161"
//       },
//       "error": {
//           "50": "#FFF0F1",
//           "100": "#FFDBDE",
//           "200": "#FFBDC2",
//           "300": "#FF99A2",
//           "400": "#FF7A86",
//           "500": "#FF505F",
//           "600": "#EB0014",
//           "700": "#C70011",
//           "800": "#94000D",
//           "900": "#570007",
//           "main": "#EB0014",
//           "light": "#FF99A2",
//           "dark": "#C70011",
//           "contrastText": "#fff"
//       },
//       "success": {
//           "50": "#E9FBF0",
//           "100": "#C6F6D9",
//           "200": "#9AEFBC",
//           "300": "#6AE79C",
//           "400": "#3EE07F",
//           "500": "#21CC66",
//           "600": "#1DB45A",
//           "700": "#1AA251",
//           "800": "#178D46",
//           "900": "#0F5C2E",
//           "main": "#1AA251",
//           "light": "#6AE79C",
//           "dark": "#1AA251",
//           "contrastText": "#fff"
//       },
//       "warning": {
//           "50": "#FFF9EB",
//           "100": "#FFF3C1",
//           "200": "#FFECA1",
//           "300": "#FFDC48",
//           "400": "#F4C000",
//           "500": "#DEA500",
//           "600": "#D18E00",
//           "700": "#AB6800",
//           "800": "#8C5800",
//           "900": "#5A3600",
//           "main": "#DEA500",
//           "light": "#FFDC48",
//           "dark": "#AB6800",
//           "contrastText": "rgba(0, 0, 0, 0.87)"
//       },
//       "secondary": {
//           "main": "#9c27b0",
//           "light": "#ba68c8",
//           "dark": "#7b1fa2",
//           "contrastText": "#fff"
//       },
//       "info": {
//           "main": "#0288d1",
//           "light": "#03a9f4",
//           "dark": "#01579b",
//           "contrastText": "#fff"
//       },
//       "contrastThreshold": 3,
//       "tonalOffset": 0.2,
//       "background": {
//           "paper": "#fff",
//           "default": "#fff"
//       },
//       "action": {
//           "active": "rgba(0, 0, 0, 0.54)",
//           "hover": "rgba(0, 0, 0, 0.04)",
//           "hoverOpacity": 0.04,
//           "selected": "rgba(0, 0, 0, 0.08)",
//           "selectedOpacity": 0.08,
//           "disabled": "rgba(0, 0, 0, 0.26)",
//           "disabledBackground": "rgba(0, 0, 0, 0.12)",
//           "disabledOpacity": 0.38,
//           "focus": "rgba(0, 0, 0, 0.12)",
//           "focusOpacity": 0.12,
//           "activatedOpacity": 0.12
//       }
//   },
//   "shape": {
//       "borderRadius": 10
//   },

// "props": {
//     "MuiBadge": {
//         "overlap": "rectangular"
//     }
// },
// "unstable_sxConfig": {
//     "border": {
//         "themeKey": "borders"
//     },
//     "borderTop": {
//         "themeKey": "borders"
//     },
//     "borderRight": {
//         "themeKey": "borders"
//     },
//     "borderBottom": {
//         "themeKey": "borders"
//     },
//     "borderLeft": {
//         "themeKey": "borders"
//     },
//     "borderColor": {
//         "themeKey": "palette"
//     },
//     "borderTopColor": {
//         "themeKey": "palette"
//     },
//     "borderRightColor": {
//         "themeKey": "palette"
//     },
//     "borderBottomColor": {
//         "themeKey": "palette"
//     },
//     "borderLeftColor": {
//         "themeKey": "palette"
//     },
//     "borderRadius": {
//         "themeKey": "shape.borderRadius"
//     },
//     "color": {
//         "themeKey": "palette"
//     },
//     "bgcolor": {
//         "themeKey": "palette",
//         "cssProperty": "backgroundColor"
//     },
//     "backgroundColor": {
//         "themeKey": "palette"
//     },
//     "p": {},
//     "pt": {},
//     "pr": {},
//     "pb": {},
//     "pl": {},
//     "px": {},
//     "py": {},
//     "padding": {},
//     "paddingTop": {},
//     "paddingRight": {},
//     "paddingBottom": {},
//     "paddingLeft": {},
//     "paddingX": {},
//     "paddingY": {},
//     "paddingInline": {},
//     "paddingInlineStart": {},
//     "paddingInlineEnd": {},
//     "paddingBlock": {},
//     "paddingBlockStart": {},
//     "paddingBlockEnd": {},
//     "m": {},
//     "mt": {},
//     "mr": {},
//     "mb": {},
//     "ml": {},
//     "mx": {},
//     "my": {},
//     "margin": {},
//     "marginTop": {},
//     "marginRight": {},
//     "marginBottom": {},
//     "marginLeft": {},
//     "marginX": {},
//     "marginY": {},
//     "marginInline": {},
//     "marginInlineStart": {},
//     "marginInlineEnd": {},
//     "marginBlock": {},
//     "marginBlockStart": {},
//     "marginBlockEnd": {},
//     "displayPrint": {
//         "cssProperty": false
//     },
//     "display": {},
//     "overflow": {},
//     "textOverflow": {},
//     "visibility": {},
//     "whiteSpace": {},
//     "flexBasis": {},
//     "flexDirection": {},
//     "flexWrap": {},
//     "justifyContent": {},
//     "alignItems": {},
//     "alignContent": {},
//     "order": {},
//     "flex": {},
//     "flexGrow": {},
//     "flexShrink": {},
//     "alignSelf": {},
//     "justifyItems": {},
//     "justifySelf": {},
//     "gap": {},
//     "rowGap": {},
//     "columnGap": {},
//     "gridColumn": {},
//     "gridRow": {},
//     "gridAutoFlow": {},
//     "gridAutoColumns": {},
//     "gridAutoRows": {},
//     "gridTemplateColumns": {},
//     "gridTemplateRows": {},
//     "gridTemplateAreas": {},
//     "gridArea": {},
//     "position": {},
//     "zIndex": {
//         "themeKey": "zIndex"
//     },
//     "top": {},
//     "right": {},
//     "bottom": {},
//     "left": {},
//     "boxShadow": {
//         "themeKey": "shadows"
//     },
//     "width": {},
//     "maxWidth": {},
//     "minWidth": {},
//     "height": {},
//     "maxHeight": {},
//     "minHeight": {},
//     "boxSizing": {},
//     "fontFamily": {
//         "themeKey": "typography"
//     },
//     "fontSize": {
//         "themeKey": "typography"
//     },
//     "fontStyle": {
//         "themeKey": "typography"
//     },
//     "fontWeight": {
//         "themeKey": "typography"
//     },
//     "letterSpacing": {},
//     "textTransform": {},
//     "lineHeight": {},
//     "textAlign": {},
//     "typography": {
//         "cssProperty": false,
//         "themeKey": "typography"
//     }
// },
// "mixins": {
//     "toolbar": {
//         "minHeight": 56,
//         "@media (min-width:0px)": {
//             "@media (orientation: landscape)": {
//                 "minHeight": 48
//             }
//         },
//         "@media (min-width:600px)": {
//             "minHeight": 64
//         }
//     }
// },
// "shadows": [
//     "none",
//     "0px 2px 1px -1px rgba(0,0,0,0.2),0px 1px 1px 0px rgba(0,0,0,0.14),0px 1px 3px 0px rgba(0,0,0,0.12)",
//     "0px 3px 1px -2px rgba(0,0,0,0.2),0px 2px 2px 0px rgba(0,0,0,0.14),0px 1px 5px 0px rgba(0,0,0,0.12)",
//     "0px 3px 3px -2px rgba(0,0,0,0.2),0px 3px 4px 0px rgba(0,0,0,0.14),0px 1px 8px 0px rgba(0,0,0,0.12)",
//     "0px 2px 4px -1px rgba(0,0,0,0.2),0px 4px 5px 0px rgba(0,0,0,0.14),0px 1px 10px 0px rgba(0,0,0,0.12)",
//     "0px 3px 5px -1px rgba(0,0,0,0.2),0px 5px 8px 0px rgba(0,0,0,0.14),0px 1px 14px 0px rgba(0,0,0,0.12)",
//     "0px 3px 5px -1px rgba(0,0,0,0.2),0px 6px 10px 0px rgba(0,0,0,0.14),0px 1px 18px 0px rgba(0,0,0,0.12)",
//     "0px 4px 5px -2px rgba(0,0,0,0.2),0px 7px 10px 1px rgba(0,0,0,0.14),0px 2px 16px 1px rgba(0,0,0,0.12)",
//     "0px 5px 5px -3px rgba(0,0,0,0.2),0px 8px 10px 1px rgba(0,0,0,0.14),0px 3px 14px 2px rgba(0,0,0,0.12)",
//     "0px 5px 6px -3px rgba(0,0,0,0.2),0px 9px 12px 1px rgba(0,0,0,0.14),0px 3px 16px 2px rgba(0,0,0,0.12)",
//     "0px 6px 6px -3px rgba(0,0,0,0.2),0px 10px 14px 1px rgba(0,0,0,0.14),0px 4px 18px 3px rgba(0,0,0,0.12)",
//     "0px 6px 7px -4px rgba(0,0,0,0.2),0px 11px 15px 1px rgba(0,0,0,0.14),0px 4px 20px 3px rgba(0,0,0,0.12)",
//     "0px 7px 8px -4px rgba(0,0,0,0.2),0px 12px 17px 2px rgba(0,0,0,0.14),0px 5px 22px 4px rgba(0,0,0,0.12)",
//     "0px 7px 8px -4px rgba(0,0,0,0.2),0px 13px 19px 2px rgba(0,0,0,0.14),0px 5px 24px 4px rgba(0,0,0,0.12)",
//     "0px 7px 9px -4px rgba(0,0,0,0.2),0px 14px 21px 2px rgba(0,0,0,0.14),0px 5px 26px 4px rgba(0,0,0,0.12)",
//     "0px 8px 9px -5px rgba(0,0,0,0.2),0px 15px 22px 2px rgba(0,0,0,0.14),0px 6px 28px 5px rgba(0,0,0,0.12)",
//     "0px 8px 10px -5px rgba(0,0,0,0.2),0px 16px 24px 2px rgba(0,0,0,0.14),0px 6px 30px 5px rgba(0,0,0,0.12)",
//     "0px 8px 11px -5px rgba(0,0,0,0.2),0px 17px 26px 2px rgba(0,0,0,0.14),0px 6px 32px 5px rgba(0,0,0,0.12)",
//     "0px 9px 11px -5px rgba(0,0,0,0.2),0px 18px 28px 2px rgba(0,0,0,0.14),0px 7px 34px 6px rgba(0,0,0,0.12)",
//     "0px 9px 12px -6px rgba(0,0,0,0.2),0px 19px 29px 2px rgba(0,0,0,0.14),0px 7px 36px 6px rgba(0,0,0,0.12)",
//     "0px 10px 13px -6px rgba(0,0,0,0.2),0px 20px 31px 3px rgba(0,0,0,0.14),0px 8px 38px 7px rgba(0,0,0,0.12)",
//     "0px 10px 13px -6px rgba(0,0,0,0.2),0px 21px 33px 3px rgba(0,0,0,0.14),0px 8px 40px 7px rgba(0,0,0,0.12)",
//     "0px 10px 14px -6px rgba(0,0,0,0.2),0px 22px 35px 3px rgba(0,0,0,0.14),0px 8px 42px 7px rgba(0,0,0,0.12)",
//     "0px 11px 14px -7px rgba(0,0,0,0.2),0px 23px 36px 3px rgba(0,0,0,0.14),0px 9px 44px 8px rgba(0,0,0,0.12)",
//     "0px 11px 15px -7px rgba(0,0,0,0.2),0px 24px 38px 3px rgba(0,0,0,0.14),0px 9px 46px 8px rgba(0,0,0,0.12)"
// ],
// "transitions": {
//     "easing": {
//         "easeInOut": "cubic-bezier(0.4, 0, 0.2, 1)",
//         "easeOut": "cubic-bezier(0.0, 0, 0.2, 1)",
//         "easeIn": "cubic-bezier(0.4, 0, 1, 1)",
//         "sharp": "cubic-bezier(0.4, 0, 0.6, 1)"
//     },
//     "duration": {
//         "shortest": 150,
//         "shorter": 200,
//         "short": 250,
//         "standard": 300,
//         "complex": 375,
//         "enteringScreen": 225,
//         "leavingScreen": 195
//     }
// },
// "zIndex": {
//     "mobileStepper": 1000,
//     "fab": 1050,
//     "speedDial": 1050,
//     "appBar": 1100,
//     "drawer": 1200,
//     "modal": 1300,
//     "snackbar": 1400,
//     "tooltip": 1500
// }
// }
